"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIcon = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

function SvgIcon(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? 'icon' : _a$className,
      icon = _a.icon,
      allProps = tslib_1.__rest(_a, ["className", "icon"]);

  return React.createElement("svg", Object.assign({
    className: className
  }, allProps), React.createElement("use", {
    xlinkHref: "#".concat(icon)
  }));
}

exports.SvgIcon = SvgIcon;